<script setup lang="ts">
import { DesignAndArchitectureSkeleton } from '.';

interface DesignDetail {
	title: string;
	value?: string | null;
}

interface DesignAndArchitectureProps {
	details: DesignDetail[];
	isLoading?: boolean;
}

defineProps<DesignAndArchitectureProps>();
</script>

<template>
	<div class="flex flex-col gap-4">
		<DesignAndArchitectureSkeleton v-if="isLoading" />
		<template v-else>
			<h2 class="text-2xl font-normal leading-9 text-primary">
				Concepção e arquitetura
			</h2>
			<div class="flex w-full flex-col rounded-lg bg-white-dark-1 p-7">
				<div class="flex flex-wrap gap-6">
					<div
						v-for="(detail, index) in details"
						:key="index"
						class="w-full md:w-[calc(50%-12px)]"
					>
						<div class="flex flex-col gap-1">
							<span class="text-sm text-[#333333]">{{ detail.title }}</span>
							<span class="text-base text-primary">{{
								detail.value || '-'
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
